const MIN_PASSWORD_LENGTH = 8;

export const PasswordHelper = {
  checkLengthRule: (password: string): boolean => password.length >= MIN_PASSWORD_LENGTH,
  checkLowerCaseRule: (password: string): boolean => !!password.match(/[a-z]/),
  checkUpperCaseRule: (password: string): boolean => !!password.match(/[A-Z]/),
  checkNumberOrSpecialCharacterRule:
    (password: string): boolean => !!password.match(/[0-9]/) || !!password.match(/[^a-zA-Z0-9]/),
};
